<div class="not-found text-center">
    <div class="inner-wrapper-not">
        <div class="notfound-404">
            <h1>{{title}}</h1>
        </div>
        <h2>{{message}}</h2>
        <button class="btn btn-info" routerLink="/login">Return To Login</button>
    </div>
</div>